import React, { useState,useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import config from "../../config/config";
import { toast } from "react-toastify";
//import ReCAPTCHAComponent from "../../common/googleCaptcha";
import VoiceInput from "../posCommon/VoiceInput";
import PaymentOptions from "./PaymentOptions";
import { sendOrderEmail } from "./sendOrderEmail";   

const auth = JSON.parse(localStorage.getItem("auth")) || {};
const userId = auth.userId;

const CheckOut = () => {
  const { API_BASE_URL, RAZOR_PAY_API_KEY } = config;
  const location = useLocation();

  const cartItems = location.state?.cartItems || [];
  const total = location.state?.total || 0;
  const deliveryCharge = location.state?.delivery || 0;

  const [loading, setLoading] = useState(false);
  //const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);

  const [orderId, setOrderId] = useState("");
  const [hemOrderId, setHemOrderId] = useState("");
  const [cartPayload, setCartPayload] = useState(null);
  const paymentRef = useRef(null);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    pinCode: "",
    address: "",
    city: "",
    state: "",
    location: "",

  });

  useEffect(() => {
  if (showPaymentOptions) {
    paymentRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}, [showPaymentOptions]);


  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (cartItems.length === 0) {
      toast.error("Cart is empty!");
      return;
    }

    setLoading(true);

    const payload = {
      orderplaceid: userId,
      total,
      deliveryCharges: deliveryCharge,
      ...formData,
      _lstUM_OrderItem: cartItems.map((item) => ({
        bookId: item.id,
        bookName: item.name,
        bookQuantity: item.quantity,
        perUnitBookPrice: item.price,
        totalBookPrice: item.price * item.quantity,
      })),
    };

    try {
      const res = await fetch(`${API_BASE_URL}/Home/Checkoutorder`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error("Order creation failed");
      }
      // Set State
      setOrderId(data.gatewayOrderID);
      setHemOrderId(data.orderId);
      setCartPayload(payload);
      setShowPaymentOptions(true);

      toast.success(`Order Created. ID: ${data.orderId}`);
      //Send Order Email
      sendOrderEmail({
        orderId: data.orderId,
        total,
        formData,
      });
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentSuccess = () => {
    localStorage.removeItem("cart");
    window.location.href = "/pos/payment-slip";
  };

  return (
    <section className="min-h-screen bg-gray-100 py-6 px-3">
      <div className="max-w-4xl mx-auto bg-white p-6 rounded-xl shadow">
        <h1 className="text-2xl font-semibold mb-4">Checkout</h1>

        <p className="mb-4 text-lg font-medium">Total: ₹{total}</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          {[
            "name",
            "mobile",
            "email",
            "pinCode",
            "address",
            "city",
            "state",
            "location"
          ].map((key) => (
            <VoiceInput
              key={key}
              name={key}
              value={formData[key]}
              onChange={handleChange}
              placeholder={key}
              label={key === "location" ? "Sale Location" : undefined}
              required={key === "name" || key === "email" || key=== "mobile" || key==="address" || key==="location"} 
            />
          ))}

          {/* <ReCAPTCHAComponent onChange={(v) => setIsCaptchaValid(!!v)} /> */}

          <button
          type="submit"
            // disabled={!isCaptchaValid || loading}
            className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? "Creating Order..." : "Place Order"}
          </button>
        </form>

        {showPaymentOptions && (
          <div ref={paymentRef}>
            <PaymentOptions
            orderId={orderId}
            hemOrderId={hemOrderId}
            total={total}
            customerData={formData}
            API_BASE_URL={API_BASE_URL}
            RAZOR_PAY_API_KEY={RAZOR_PAY_API_KEY}
            cartPayload={cartPayload}
            discount={0}
            actualPrice={total}
            onSuccess={handlePaymentSuccess}
          />
          </div>
        )}
      </div>
    </section>
  );
};

export default CheckOut;

// import React, { useState } from "react";
// import { useLocation } from "react-router-dom";
// import config from "../../config/config";
// import { toast } from "react-toastify";
// //import RenderRazorpay from "../../common/RenderRazorPay";
// import ReCAPTCHAComponent from "../../common/googleCaptcha";
// import VoiceInput from "../posCommon/VoiceInput";
// import PaymentOptions from "./PaymentOptions";  // Import your PaymentOptions component

// const CheckOut = () => {
//   const { API_BASE_URL, RAZOR_PAY_API_KEY, RAZOR_PAY_API_SECRET } = config;
//   const location = useLocation();
//   const cartItems = location.state?.cartItems || [];
//   const total = location.state?.total || 0;
//   const deliveryCharge = location.state?.delivery || 0;

//   const [displayRazorpay, setDisplayRazorpay] = useState(false);
//   const [orderId, setOrderId] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [isCaptchaValid, setIsCaptchaValid] = useState(false);
//   const [showPaymentOptions, setShowPaymentOptions] = useState(false);  // State to control payment options

//   const [preFillFormData, setPreFillFormData] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//   });

//   const [formData, setFormData] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     pinCode: "",
//     address: "",
//     city: "",
//     state: "",
//   });

//   const handleChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (cartItems.length === 0) {
//       toast.error("Cart is empty!");
//       return;
//     }

//     setLoading(true);

//     setPreFillFormData({
//       name: formData.name,
//       mobile: formData.mobile,
//       email: formData.email,
//     });

//     const payload = {
//       total,
//       deliveryCharges: deliveryCharge,
//       ...formData,
//       _lstUM_OrderItem: cartItems.map((item) => ({
//         bookId: item.id,
//         bookName: item.booknameinenglish || item.name,
//         bookQuantity: item.quantity,
//         perUnitBookPrice: item.discountedprice || item.price,
//         totalBookPrice: (item.discountedprice || item.price) * item.quantity,
//       })),
//     };

//     try {
//       const res = await fetch(`${API_BASE_URL}/Home/Checkoutorder`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const data = await res.json();
//       setOrderId(data.gatewayOrderID);
//       setLoading(false);

//       toast.success(`Order placed. Order ID: ${data.orderId}`, {
//         autoClose: false,
//       });

//       // Display PaymentOptions after placing order
//       setShowPaymentOptions(true);  // Trigger display of payment options
//     } catch {
//       toast.error("Something went wrong");
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="bg-white min-h-screen w-full">
//       <div className="max-w-7xl mx-auto px-3 sm:px-6 py-6">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//           {/* LEFT */}
//           <div>
//             <h1 className="text-xl sm:text-2xl font-semibold underline mb-4">
//               Checkout
//             </h1>

//             <p className="bg-blue-600 text-white w-fit px-4 py-1 rounded text-sm sm:text-base">
//               Total Price: <span className="font-semibold">₹{total}</span>
//             </p>

//             <p className="text-gray-700 mt-3 text-sm sm:text-base">
//               Kindly fill the form to proceed
//             </p>

//             <p className="text-gray-700 text-sm sm:text-base mt-1">
//               Support: <span className="font-semibold">+91 9958410093</span>
//             </p>

//             <p className="text-xs text-gray-500 mt-2">
//               Tap the mic icon inside input fields and speak to auto-fill
//             </p>
//           </div>

//           {/* RIGHT */}
//           <div className="bg-gray-100 rounded-lg shadow p-4 sm:p-6">
//             <h2 className="font-bold text-lg mb-4">Delivery Address</h2>

//             <form onSubmit={handleSubmit} className="space-y-4">
//               {[["name", "Name"], ["mobile", "Mobile Number"], ["email", "Email Address"], ["pinCode", "Pincode"], ["address", "Full Address"], ["city", "City"], ["state", "State"]].map(([key, label]) => (
//                 <div key={key}>
//                   <label className="text-sm font-medium text-gray-700 mb-1 block">
//                     {label}
//                   </label>
//                   <VoiceInput
//                     name={key}
//                     value={formData[key]}
//                     onChange={handleChange}
//                     placeholder={`Speak or type ${label}`}
//                     required
//                   />
//                 </div>
//               ))}

//               <ReCAPTCHAComponent onChange={(v) => setIsCaptchaValid(!!v)} />

//               <button
//                 disabled={!isCaptchaValid || loading}
//                 className={`w-full py-3 rounded text-white transition ${
//                   isCaptchaValid
//                     ? "bg-blue-600 hover:bg-blue-700"
//                     : "bg-gray-400 cursor-not-allowed"
//                 }`}
//               >
//                 {loading ? "Placing Order..." : "Place Order"}
//               </button>
//             </form>

//             {/* Render Payment Options after clicking Place Order*/}
//             {showPaymentOptions && (
//               <PaymentOptions
//                 withoutTotalDiscountPrice={total}
//                 paymentMode={() => {}}
//                 total={total}
//                 orderId={orderId}
//                 RAZOR_PAY_API_KEY={RAZOR_PAY_API_KEY}
//                 RAZOR_PAY_API_SECRET={RAZOR_PAY_API_SECRET}
//                 preFillFormData={preFillFormData}
//               />
//             )}

//             {/* Optionally, you can render Razorpay here if needed */}
//             {/* {showPaymentOptions && (
//               <RenderRazorpay
//                 amount={total}
//                 currency="INR"
//                 orderId={orderId}
//                 keyId={RAZOR_PAY_API_KEY}
//                 keySecret={RAZOR_PAY_API_SECRET}
//                 preFillFormData={preFillFormData}
//               />
//             )} */}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CheckOut;

// import React, { useState } from "react";
// import { useLocation } from "react-router-dom";
// import config from "../../config/config";
// import { toast } from "react-toastify";
// import RenderRazorpay from "../../common/RenderRazorPay";
// import ReCAPTCHAComponent from "../../common/googleCaptcha";
// import VoiceInput from "../posCommon/VoiceInput";
// import PaymentOptions from "./PaymentOptions";

// const CheckOut = () => {
//   const { API_BASE_URL, RAZOR_PAY_API_KEY, RAZOR_PAY_API_SECRET } = config;
//   const location = useLocation();

//   const cartItems = location.state?.cartItems || [];
//   const total = location.state?.total || 0;
//   const deliveryCharge = location.state?.delivery || 0;

//   const [displayRazorpay, setDisplayRazorpay] = useState(false);
//   const [orderId, setOrderId] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [isCaptchaValid, setIsCaptchaValid] = useState(false);

//   const [preFillFormData, setPreFillFormData] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//   });

//   const [formData, setFormData] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     pinCode: "",
//     address: "",
//     city: "",
//     state: "",
//   });

//   const handleChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (cartItems.length === 0) {
//       toast.error("Cart is empty!");
//       return;
//     }

//     setLoading(true);

//     setPreFillFormData({
//       name: formData.name,
//       mobile: formData.mobile,
//       email: formData.email,
//     });

//     const payload = {
//       total,
//       deliveryCharges: deliveryCharge,
//       ...formData,
//       _lstUM_OrderItem: cartItems.map((item) => ({
//         bookId: item.id,
//         bookName: item.booknameinenglish || item.name,
//         bookQuantity: item.quantity,
//         perUnitBookPrice: item.discountedprice || item.price,
//         totalBookPrice: (item.discountedprice || item.price) * item.quantity,
//       })),
//     };

//     try {
//       const res = await fetch(`${API_BASE_URL}/Home/Checkoutorder`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const data = await res.json();
//       setOrderId(data.gatewayOrderID);
//       setDisplayRazorpay(true);
//       setLoading(false);

//       toast.success(`Order placed. Order ID: ${data.orderId}`, {
//         autoClose: false,
//       });
//     } catch {
//       toast.error("Something went wrong");
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="bg-white min-h-screen w-full">
//       <div className="max-w-7xl mx-auto px-3 sm:px-6 py-6">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//           {/* LEFT */}
//           <div>
//             <h1 className="text-xl sm:text-2xl font-semibold underline mb-4">
//               Checkout
//             </h1>

//             <p className="bg-blue-600 text-white w-fit px-4 py-1 rounded text-sm sm:text-base">
//               Total Price: <span className="font-semibold">₹{total}</span>
//             </p>

//             <p className="text-gray-700 mt-3 text-sm sm:text-base">
//               Kindly fill the form to proceed
//             </p>

//             <p className="text-gray-700 text-sm sm:text-base mt-1">
//               Support: <span className="font-semibold">+91 9958410093</span>
//             </p>

//             <p className="text-xs text-gray-500 mt-2">
//               Tap the mic icon inside input fields and speak to auto-fill
//             </p>
//           </div>

//           {/* RIGHT */}
//           <div className="bg-gray-100 rounded-lg shadow p-4 sm:p-6">
//             <h2 className="font-bold text-lg mb-4">Delivery Address</h2>

//             <form onSubmit={handleSubmit} className="space-y-4">
//               {[
//                 ["name", "Name"],
//                 ["mobile", "Mobile Number"],
//                 ["email", "Email Address"],
//                 ["pinCode", "Pincode"],
//                 ["address", "Full Address"],
//                 ["city", "City"],
//                 ["state", "State"],
//               ].map(([key, label]) => (
//                 <div key={key}>
//                   <label className="text-sm font-medium text-gray-700 mb-1 block">
//                     {label}
//                   </label>
//                   <VoiceInput
//                     name={key}
//                     value={formData[key]}
//                     onChange={handleChange}
//                     placeholder={`Speak or type ${label}`}
//                     required
//                   />
//                 </div>
//               ))}

//               <ReCAPTCHAComponent onChange={(v) => setIsCaptchaValid(!!v)} />

//               <button
//                 disabled={!isCaptchaValid || loading}
//                 className={`w-full py-3 rounded text-white transition ${
//                   isCaptchaValid
//                     ? "bg-blue-600 hover:bg-blue-700"
//                     : "bg-gray-400 cursor-not-allowed"
//                 }`}
//               >
//                 {loading ? "Placing Order..." : "Place Order"}
//               </button>

//               {displayRazorpay && (
//                 <RenderRazorpay
//                   amount={total}
//                   currency="INR"
//                   orderId={orderId}
//                   keyId={RAZOR_PAY_API_KEY}
//                   keySecret={RAZOR_PAY_API_SECRET}
//                   preFillFormData={preFillFormData}
//                 />
//               )}
//             </form>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CheckOut;
